// import StageOne from "../Views/StageOne";
import Login from "../Views/Login";

const routes = [{ path: "/login", element: <Login /> }];

export default routes;
